module.exports = __webpack_public_path__ + "static/media/options-english.36ac3795.png";